import { type ImageLoader, type ImageLoaderProps } from 'next/image'

import { useCdnContext } from '../../cdn'

const getNormalizeFileName = (fileName: string, cdnUrlLength: number): string =>
  fileName.slice(cdnUrlLength).replace(/^\d+x\d+\//u, '')

const imageLoader = (
  cdnUrl: string,
  { src, width }: ImageLoaderProps,
): string => {
  if (!src.startsWith(cdnUrl)) {
    return src
  }

  const normalizeFileName = getNormalizeFileName(src, cdnUrl.length)
  const urlWithSize = new URL(`${width}x0/`, cdnUrl)
  const urlWithSizeAndFileName = new URL(normalizeFileName, urlWithSize.href)

  return urlWithSizeAndFileName.href
}

export const useCdnHostedImageLoader = (): ImageLoader => {
  const { productImageCdnUrl } = useCdnContext()

  return (imageLoaderProps: ImageLoaderProps) => {
    return imageLoader(
      new URL('/images/', productImageCdnUrl).href,
      imageLoaderProps,
    )
  }
}
